(ns
  frontend.ui.component.lp-portal.report.body.private-equity.holding.new-investment-company.pdf.view
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.card.pdf.view :refer [card]]
   [frontend.ui.component.lp-portal.column.pdf.view
    :refer [column columns columns-2-to-1]]
   [frontend.ui.component.lp-portal.page.pdf.view
    :as page]
   [frontend.ui.component.lp-portal.stacked-text-group.pdf.view
    :refer [stacked-text-group]]
   [frontend.ui.page.lp-portal.report.pdf.view :refer [report]]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [potpuri.core :as potpuri]))

(defn overview-pages
  [report-data]
  [(page/page
    (page/third-column-background)
    (page/page-title {:page-title
                      (str (:holding-name report-data) " - new investment")
                      :toc-item   true})
    (columns-2-to-1
     {:stack [(card
               "Case Overview"
               (text-content/rich-content (->> report-data
                                               :case-overview-text
                                               :rich-content)))]}
     {:margin [0 15 0 0]
      :stack  (->> report-data
                   :overview-figures
                   :figures
                   (map
                    (fn [[label value]]
                      (stacked-text-group label value))))}))
   (page/page
    nil
    (page/page-title {:page-title
                      (str (:holding-name report-data) " - new investment")})
    (columns
     {:stack [(card
               "Financials"
               {:svg   (chart-view/chart-svg "highcharts"
                                             (potpuri/deep-merge
                                              (-> report-data
                                                  :financials
                                                  :figures)
                                              {:chart {:width  800
                                                       :height 360}}))
                :width 530}
               (text-content/optional-footer (:financials report-data)) ; is this ever used?
              )]}))])

(defn dasos-overview-pages
  [report-data]
  [(page/page
    (page/third-column-background)
    (page/page-title {:page-title
                      (str (:holding-name report-data))
                      :toc-item   true})
    (columns-2-to-1
     {:stack [(card
               "Case Overview"
               (text-content/rich-content (->> report-data
                                               :case-overview-text
                                               :rich-content)))]}
     {:margin [0 15 0 0]
      :stack  (->> report-data
                   :overview-figures
                   :figures
                   (map
                    (fn [[label value]]
                      (stacked-text-group label value))))}))
   (page/page
    nil
    (page/page-title {:page-title
                      (str (:holding-name report-data))})
    (columns
     {:stack [(card
               "Financials"
               {:svg   (chart-view/chart-svg "highcharts"
                                             (potpuri/deep-merge
                                              (-> report-data
                                                  :financials
                                                  :figures)
                                              {:chart {:width  800
                                                       :height 360}}))
                :width 530}
               (text-content/optional-footer (:financials report-data)) ; is this ever used?
               )]}))])

(defn holding-pages
  [report-data]
  (overview-pages report-data))

(defn dasos-holding-pages
  [report-data]
  (dasos-overview-pages report-data))

(defn new-investment-company
  [{:keys [reporting-period reference-date] :as view-data}]
  (report view-data
          (holding-pages view-data)
          "PE holding company"
          reporting-period
          reference-date))
